import { render, staticRenderFns } from "./ResultsList.vue?vue&type=template&id=49dbecd6&"
import script from "./ResultsList.vue?vue&type=script&lang=ts&"
export * from "./ResultsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports